import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Landing from './pages/Landing';
import Home from './pages/Home';
import Vintage from './pages/Vintage';
import BrandDenim from './pages/BrandDenim';
import ProductDetail from './pages/ProductDetail';
import UnderConstruction from './pages/UnderConstruction';
import './App.css';

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <ScrollToTop />
      <Routes>
        {/* Landing page without header/footer */}
        <Route path="/" element={<Landing />} />

        {/* Home page with header/footer */}
        <Route path="/home" element={
          <div className="App">
            <Header />
            <main className="main-content">
              <Home />
            </main>
            <Footer />
          </div>
        } />

        {/* Vintage shop page */}
        <Route path="/shop/vintage" element={
          <div className="App">
            <Header />
            <main className="main-content">
              <Vintage />
            </main>
            <Footer />
          </div>
        } />

        {/* Brand denim page */}
        <Route path="/shop/brand-denim" element={
          <div className="App">
            <Header />
            <main className="main-content">
              <BrandDenim />
            </main>
            <Footer />
          </div>
        } />

        {/* Product detail page */}
        <Route path="/products/:slug" element={
          <div className="App">
            <Header />
            <main className="main-content">
              <ProductDetail />
            </main>
            <Footer />
          </div>
        } />

        {/* Under construction page */}
        <Route path="/under-construction" element={
          <div className="App">
            <Header />
            <main className="main-content">
              <UnderConstruction />
            </main>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
